import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { View } from "@/styles/reactnative";
import { TradeRealTimeContainer } from "./styles";

import OrderBook from "./OrderBook";
import TradeRealTimeFilter from "./TradeRealTimeFilter";
import TickSizeSelector from "./OrderBook/TickSizeSelector";
import { useTradeModalStore } from "../../../hooks/trade/modalStore";
import { useWindowDimensions } from "../../../hooks";
import useTradeStore from "../../../hooks/trade/tradeStore";
import { useBinanceWebSocketStore } from '@app/hooks/binanceWebsocketStore.ts';
import { useCiTradeWebSocketStore } from '@app/hooks/ciTradeWebsocketStore.ts';

// 종목별 기본 tick size 옵션 생성
const getTickSizeOptions = (dp: number): number[] => {
  const baseTickSize = Math.pow(10, -dp);
  const options: number[] = [];
  for (let i = 0; i < 4; i++) {
    options.push(baseTickSize * Math.pow(10, i));
  }
  return options;
};

const TradeRealTime = ({ drag, setOrderBookValue }) => {
  const [topTab, setTopTab] = useState("orderBook");
  const [filterTab, setFilterTab] = useState("one");
  const { width: w, height: h } = useWindowDimensions();
  const { data: tradeStore } = useTradeStore();

  const setSymbol = useCiTradeWebSocketStore((s) => s.setSymbol);
  const closeSocket = useCiTradeWebSocketStore((s) => s.closeSocket);

  useEffect(() => {
    if (!tradeStore?.pairs) return;

    const rawSymbol = tradeStore.pairs.replace("/", "").toLowerCase();
    setSymbol(rawSymbol);

    return () => {
      closeSocket();
    };
  }, [tradeStore?.pairs, setSymbol, closeSocket]);


  const orderBook = topTab === "orderBook";

  const { data: tradeModalStore, mutate: muateTradeModalStore } =
    useTradeModalStore();

  const [height, setHeight] = useState(500);

  const parentRef = useRef<any>(null);

  useEffect(() => {
    if (parentRef.current) {
      if (parentRef.current?.clientHeight != height) {
        setTimeout(() => {
          setHeight(parentRef.current?.clientHeight - 100);
        }, 100);
        setTimeout(() => {
          setHeight(parentRef.current?.clientHeight - 100);
        }, 500);
      }
    }
  }, [w, h, parentRef.current?.clientHeight, drag]);

  const grouplist =
    tradeStore?.dp == 1 ? [100, 10, 1] : tradeStore?.dp == 2 ? [10, 1] : [1];

  for (let i = 1; i <= tradeStore?.dp; i++) {
    const value = parseFloat((0.1 ** i).toFixed(i));
    grouplist.push(value === 0 ? 1 : value);
  }

  const [selected, setSelected] = useState(grouplist[grouplist?.length - 1]);

  useEffect(() => {
    setSelected(grouplist[grouplist?.length - 1]);
  }, [tradeStore?.dp2, tradeStore?.ep_id]);

  // Tick size 관련 상태
  const dp = tradeStore?.dp || 2;
  const tickSizeOptions = useMemo(() => getTickSizeOptions(dp), [dp]);
  const [tickSize, setTickSize] = useState<number>(tickSizeOptions[0]);

  // dp 변경 시 tick size 초기화
  useEffect(() => {
    const newOptions = getTickSizeOptions(dp);
    setTickSize(newOptions[0]);
  }, [dp]);

  const handleTickSizeChange = useCallback((newTickSize: number) => {
    setTickSize(newTickSize);
  }, []);

  return (
    <TradeRealTimeContainer ref={parentRef}>

      <View style={{
        width: "100%",
        height: 65,
        display: 'flex',
        flexDirection: 'row',
        paddingRight: 10,
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            zIndex: 1
          }}
          onMouseDown={(e) => e.stopPropagation()}
          onTouchStart={(e) => e.stopPropagation()}
        >
          <TradeRealTimeFilter
            filterTab={filterTab}
            setFilterTab={setFilterTab}
            grouplist={grouplist}
            selected={selected}
            setSelected={setSelected}
          />
        </div>

        <div
          className="drag-handle"
          style={{
            flex: 1,
            height: '100%',
            cursor: 'move'
          }}
        />

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            zIndex: 1
          }}
          onMouseDown={(e) => e.stopPropagation()}
          onTouchStart={(e) => e.stopPropagation()}
        >
          <TickSizeSelector
            tickSize={tickSize}
            tickSizeOptions={tickSizeOptions}
            onChange={handleTickSizeChange}
          />
        </div>
      </View>
      <View
        style={{
          width: "100%",
          flex: 1,
          alignItems: "flex-start",
          justifyContent: "flex-start",
        }}
      >
        <OrderBook
          orderBook={orderBook}
          filterTab={filterTab}
          height={height}
          selected={selected}
          setOrderBookValue={setOrderBookValue}
          tickSize={tickSize}
          tickSizeOptions={tickSizeOptions}
        />
      </View>
    </TradeRealTimeContainer>
  );
};

export default React.memo(TradeRealTime);
